import { INITIALIZE_AGREEMENT_VERSION } from 'src/app/pages/shared/constants';
import { IntegerValue } from '../abstract/integer-value';
import { PreferNominal } from '../abstract/prefer-nominal';

export class PrivacyPolicyVersion extends IntegerValue {
  version!: PreferNominal;

  constructor(value: number = INITIALIZE_AGREEMENT_VERSION) {
    super(value);
  }
}
